import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "list-product table-responsive theme-scrollbar card d-flex flex-column justify-content-between gap-3 p-3",
  style: {"min-height":"512px"}
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "w-100 d-flex gap-3" }
const _hoisted_4 = { class: "mb-3 row justify-content-start" }
const _hoisted_5 = {
  for: "table-complete-department",
  class: "col-xs-3 col-sm-auto col-form-label"
}
const _hoisted_6 = { class: "col-xs-3 col-sm-auto" }
const _hoisted_7 = { value: "all" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "mb-3 row justify-content-start" }
const _hoisted_10 = {
  for: "table-complete-search",
  class: "col-xs-3 col-sm-auto col-form-label"
}
const _hoisted_11 = { class: "col-xs-3 col-sm-auto" }
const _hoisted_12 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-original-title": "test",
  "data-bs-target": "#product-add-modal"
}
const _hoisted_13 = {
  class: "table display",
  id: "project-status"
}
const _hoisted_14 = { class: "f-light f-w-600" }
const _hoisted_15 = { class: "f-light f-w-600" }
const _hoisted_16 = { class: "f-light f-w-600" }
const _hoisted_17 = { class: "f-light f-w-600" }
const _hoisted_18 = { class: "f-light f-w-600" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "odd" }
const _hoisted_21 = {
  valign: "top",
  colspan: "6",
  class: "dataTables_empty"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "product-names" }
const _hoisted_24 = {
  key: 0,
  class: "light-product-box"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "w-100" }
const _hoisted_28 = { class: "pagination justify-content-center pagination-primary" }
const _hoisted_29 = { class: "page-item" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "page-link" }
const _hoisted_32 = { class: "page-item" }

import { ref, onMounted, reactive, computed, defineAsyncComponent } from 'vue'
import { useWindowSize } from '@vueuse/core';
import { useProductsStore, defaultProduct } from '@/store/management/productsStore';
import type { Product } from '@/store/management/productsStore';
import router from '@/router';

import { useI18n } from 'vue-i18n'
import { productListTableLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productListTable',
  setup(__props) {

const { t } = useI18n({
  messages: productListTableLanguage
})

const productAddModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productAddModal.vue'))

const productsStore = useProductsStore();

const compState = reactive({
    searchQuery: '',
    department: 'all',
})

const { height: screenHeight } = useWindowSize();
const elementsPerPage = computed(() => {
    if (screenHeight.value > 1200) {
        return 10;
    } else if (screenHeight.value > 800) {
        return 7;
    } else {
        return 5;
    }
});
const currentPage = ref<number>(1)

const productsList = computed(() => {
    return productsStore.getAllProducts(compState.department, compState.searchQuery);
});

const departmentList = computed(() => {
    return productsStore.getDepartmentList;
});

function get_rows() {
    var start = (currentPage.value - 1) * elementsPerPage.value;
    var end = start + elementsPerPage.value;
    return productsList.value.slice(start, end);
}
function num_pages() {
    return Math.ceil(productsList.value.length / elementsPerPage.value);
}
function change_page(page: number) {
    currentPage.value = page;
}
function change() {
    if (currentPage.value < Math.ceil(productsList.value.length / elementsPerPage.value)) {
        currentPage.value++;
    }
}
function prev() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}
onMounted(() => {
    if (productsList.value.length === 0) {
        productsStore.initializeDepartments();
        productsStore.initActiveProduct(defaultProduct);
        console.log('add new products');
    }
})

function onProductClick(id: string) {
    router.push('/management/products/details/' + id);
}

const onProductSave = (payload: Product) => {
    console.log(payload);

    productsStore.addProduct(payload);
    console.log(productsList.value);
    // router.push('/management/products/details/' + payload.basic.productNumber);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('Department')) + ":", 1),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  id: "table-complete-department",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.department) = $event))
                }, [
                  _createElementVNode("option", _hoisted_7, _toDisplayString(_unref(t)('All')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departmentList.value, (department) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: department.name,
                      value: department.name
                    }, _toDisplayString(department.name), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, compState.department]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('Search')) + ":", 1),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  id: "table-complete-search",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.searchQuery) = $event))
                }, null, 512), [
                  [_vModelText, compState.searchQuery]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_12, _toDisplayString(_unref(t)('Add Product')), 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('Product Name')), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('Department')), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('Qty')), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('Price')), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('Barcode')), 1)
                ])
              ])
            ]),
            (!get_rows().length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createElementVNode("tr", _hoisted_20, [
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(t)('No matching records found')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_rows(), (row, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "product-removes hover-pointer hover-shadow",
                  onClick: ($event: any) => (onProductClick(row.basic.productNumber)),
                  key: index
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_23, [
                      (row.appearance.image)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("img", {
                              class: "img-fluid",
                              src: row.appearance.image,
                              alt: "img"
                            }, null, 8, _hoisted_25)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[4] || (_cache[4] = [
                            _createElementVNode("div", { class: "light-product-box" }, null, -1)
                          ]))),
                      _createTextVNode(" " + _toDisplayString(row.basic.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(row.basic.department), 1),
                  _createElementVNode("td", null, _toDisplayString(row.stock.currentStockLevel), 1),
                  _createElementVNode("td", null, _toDisplayString(row.priceLevels[0]?.price || 'N/A'), 1),
                  _createElementVNode("td", null, _toDisplayString(row.basic.barcode), 1)
                ], 8, _hoisted_22))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("ul", _hoisted_28, [
          _createElementVNode("li", _hoisted_29, [
            _createElementVNode("a", {
              class: "page-link",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (prev())),
              "aria-label": "Previous"
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "«", -1)
            ]))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(num_pages(), (i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["page-item", [i == currentPage.value ? 'active' : '']]),
              key: i,
              onClick: ($event: any) => (change_page(i))
            }, [
              _createElementVNode("a", _hoisted_31, _toDisplayString(i), 1)
            ], 10, _hoisted_30))
          }), 128)),
          _createElementVNode("li", _hoisted_32, [
            _createElementVNode("a", {
              class: "page-link",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (change())),
              "aria-label": "Next"
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "»", -1)
            ]))
          ])
        ])
      ])
    ]),
    _createVNode(_unref(productAddModal), { onOnSave: onProductSave })
  ], 64))
}
}

})